export enum ToggleKey {
  CategorySwap = "TROCA_CATEGORIA",
  CauseOfDeathRegistration = "CADASTRO_CAUSA_MORTE",
  ConsumptionClosure = "FECHAMENTO_CONSUMO_PRODUTO",
  Creep = "CREEP_MANEJO",
  DeathsAndBirths = "MORTE_NASCIMENTO",
  DrumCollection = "COLETA_BOMBONA",
  FormulationRegistration = "COLETA_DE_FORMULACAO",
  LotGoalRegistration = "CADASTRO_OBJETIVO_LOTE",
  ProjectedWeightColumn = "COLUNA_PESO_PROJETADO",
  Rain = "CHUVA",
  SanityCollection = "COLETA_SANIDADE",
  SemiConfinement = "SEMI_CONFINAMENTO",
  WeightGainRegistration = "CADASTRO_GANHO_PESO",
  ForageCycleManagement = "GESTAO_CICLO_FORRAGEM",
  ParticipationBenchmark = "CONFIGURAR_PARTICIPACAO_BENCHMARK",
}
